<template>
    <div id="responsiveIframe">
        <div id="responsiveIframeSlot">
            <slot></slot>
        </div>
        <iframe :src="src" :style="'width:100%;height:' + height" />
    </div>
</template>

<script>
export default {
    name: 'responsiveIframe',
    props: {
        src: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            height: '100%',
        };
    },
    created() {
        //this.handleIframeSize();
        window.addEventListener('resize', this.handleIframeSize);
    },
    mounted() {
        this.handleIframeSize();
    },
    methods: {
        handleIframeSize() {
            var slotElement = document.getElementById('responsiveIframeSlot');
            var slotHeight = slotElement.clientHeight;
            var topHeight = slotElement.getBoundingClientRect().top + 70;
            this.height = window.innerHeight - slotHeight - topHeight + 'px';
        },
    },
};
</script>
